import { createStyles } from '@mantine/core';

import { RAIL_CARD_WIDTH, RAIL_CARD_WIDTH_DESKTOP } from '../../constants/rail';

export const useStyles = createStyles((theme) => ({
  railContainer: {
    // Allows shadow of the rail to overflow the container
    marginTop: -theme.other.spacing._8,
    marginBottom: -theme.other.spacing._16,
    marginLeft: -theme.other.spacing._16,
    width: '100vw',

    [theme.fn.largerThan('md')]: {
      marginLeft: -theme.other.spacing._24,

    },
    [theme.fn.largerThan('lg')]: {
      marginLeft: -theme.other.spacing._32,

    },
    [theme.fn.largerThan('xl')]: {
      marginLeft: 0,
      marginRight: 0,
      width: '100%',
    },
  },
  rail: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: RAIL_CARD_WIDTH,
    gridTemplateRows: 'auto',
    gap: theme.other.spacing._8,
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._16,
    paddingLeft: theme.other.spacing._16,
    paddingRight: theme.other.spacing._16,

    [theme.fn.largerThan('md')]: {
      gridAutoColumns: RAIL_CARD_WIDTH_DESKTOP,
      gap: theme.other.spacing._16,
      paddingLeft: theme.other.spacing._24,
      paddingRight: theme.other.spacing._24,
    },
    [theme.fn.largerThan('lg')]: {
      paddingLeft: -theme.other.spacing._32,
      paddingRight: -theme.other.spacing._32,
    },
    [theme.fn.largerThan('xl')]: {
      paddingLeft: 0,
      paddingRight: 0,
      width: '100%',
    },
  },
  slide: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
}));
